// @ts-check
import MatchingResult from './MatchingResult';

export default MatchingResult;
